import { render, staticRenderFns } from "./ItemPreview.vue?vue&type=template&id=58c7678b&scoped=true"
import script from "./ItemPreview.vue?vue&type=script&lang=js"
export * from "./ItemPreview.vue?vue&type=script&lang=js"
import style0 from "./ItemPreview.vue?vue&type=style&index=0&id=58c7678b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c7678b",
  null
  
)

export default component.exports